import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		tableSortable_sortIcon: {
			color: `inherit !important`,
		},
		tableSortable_sortActive: {

		},
		tableSortable_sortContainer: {
			color: theme.palette.primary.contrastText,
			"&:hover": {
				color: theme.palette.primary.contrastText,
				textShadow: `0 0 7px ${theme.palette.primary.contrastText}`
			},
			'&$tableSortable_sortActive': {
				color: theme.palette.primary.contrastText,
				textShadow: `0 0 7px ${theme.palette.primary.contrastText}`
			},
		},
	});
});

export default useStyles;
